/* eslint-disable camelcase */
/**
 * @author Fernando Ruano
 * @file index.js
 * @description Role Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { role: roleEndpoints, rolePermission: rolePermissionEndpoints } =
  endpoints;

export class RoleService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get roles list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get roles list.
   */
  getRoles = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = roleEndpoints.base;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get role info by id
   * @param { string } id - Role id.
   * @return { Object } - Get roles list.
   */
  getRoleById = async (id) => {
    const url = `${roleEndpoints.base}/${id}`;
    return this.http.get(url);
  };

  /**
   * Create role
   * @param { string } name - Role name.
   * @param { string } description - Role description.
   * @return { promise } - The role promise object.
   */
  createRole = async (name, description) => {
    const body = { name, description };
    const url = roleEndpoints.base;
    return this.http.post(url, body);
  };

  /**
   * Delete role by id
   * @param { string } id - Role id.
   * @return { Object } - Get roles list.
   */
  deleteRoleById = async (id) => {
    const url = `${roleEndpoints.base}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Update role
   * @param { string } name - Role name.
   * @param { string } description - Role description.
   * @param { string } id - Role id.
   * @return { promise } - The role promise object.
   */
  updateRole = async (name, description, id) => {
    const body = { name, description };
    const url = `${roleEndpoints.base}/${id}`;
    return this.http.update(url, body, {}, 'put');
  };

  /**
   * Create role permission
   * @param { Object } item_menu - Item menu data.
   * @param { Object } permission - Permission data.
   * @param { Object } role - Role data.
   * @return { promise } - The role permission promise object.
   */
  createRolePermission = async (item_menu, permission, role) => {
    const body = { item_menu, permission, role };
    const url = rolePermissionEndpoints.base;
    return this.http.post(url, body);
  };

  /**
   * Delete role permission by id
   * @param { string } id - Role permission id.
   * @return { Object } - Get roles list.
   */
  deleteRolePermissionById = async (id) => {
    const url = `${rolePermissionEndpoints.base}/${id}`;
    return this.http.delete(url);
  };
}

export default new RoleService(externalConnector);
